import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getMoment } from '../services/datetime.service';

@Pipe({
  name: 'timePresentation'
})
export class TimePresentationPipe implements PipeTransform {

  constructor() { }

  public transform(value: string, args?: any): string {
    if (value === '0001-01-01T00:00:00+00:00' || value === '1900-01-01T00:00:00+00:00') {
      return '-';
    } else {
      const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
      const message = getMoment(value, format).format((!args) ? 'HH:mm' : 'HH:mm:ss') ;
      return message;
    }
  }

}
